import React from 'react';
import { FormattedMessage } from 'react-intl';

const Radiocomando = ({ current, auth, system }) => {
    const sup = system.store.state.ingr.supervisione_ingressi === true
    return (
        <>
            <div className="rack bottomBorder">
                <div className="w33">
                    <div className="switchButton">
                        <input type="checkbox" className="switch" id="elettroserratura" name="k" defaultValue="0" defaultChecked={current.k} disabled={auth !== 2 || sup} />
                        <label htmlFor={`elettroserratura`}>
                            <span>
                                <span />
                            </span>
                            <FormattedMessage id="App.info.Elettroserratura" />
                        </label>
                    </div>
                </div>
                <div className="w33">
                    <div className="switchButton">
                        <input type="checkbox" className="switch" id="antipanico" name="sempre_attivo" defaultValue="0" defaultChecked={current.sempre_attivo} disabled={auth !== 2 || sup} />
                        <label htmlFor={`antipanico`}>
                            <span>
                                <span />
                            </span>
                            <FormattedMessage id="App.info.Antipanico" />
                        </label>
                    </div>
                </div>
                <div className="w33">
                    <div className="switchButton">
                        <input type="checkbox" className="switch" id="ronda" name="ritardato" defaultValue="0" defaultChecked={current.ritardato} disabled={auth !== 2 || sup} />
                        <label htmlFor={`ronda`}>
                            <span>
                                <span />
                            </span>
                            <FormattedMessage id="App.info.Ronda" />
                        </label>
                    </div>
                </div>
                <div className="w33">
                    <div className="switchButton">
                        <input type="checkbox" className="switch" id="silenzioso" name="percorso" defaultValue="0" defaultChecked={current.percorso} disabled={auth !== 2 || sup} />
                        <label htmlFor={`silenzioso`}>
                            <span>
                                <span />
                            </span>
                            <FormattedMessage id="App.info.Silenzioso" />
                        </label>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Radiocomando;